import { RoutedModal } from "../../../common";
import secondaryComponents from "../..";
import { useContext, useState } from "react";
import primaryComponents from "../../../primaryComponents";
import EditIconV2 from "../../../../assets/svgIcons/EditIconV2";
import { ToastContext } from "../../../../hooks/context";

export const BulkUpdateProduct = ({
  type,
  formData = {},
  setFormData = () => {},
}) => {
  const [isBulkEdit, setIsBulkEdit] = useState(false);
  const triggerToast = useContext(ToastContext);

  return (
    <>
      <primaryComponents.Button
        classNames={"btn btn--outline"}
        onClick={() => {
          if (!formData?.is_select_all && !formData?.selected_ids?.length)
            return triggerToast("Select at one product to proceed");

          setIsBulkEdit(true);
        }}
      >
        Bulk Update <EditIconV2 className="ml-1" />
      </primaryComponents.Button>

      <RoutedModal
        width={850}
        headerTitle="Bulk Update"
        headerDescription={`Select an action below to apply on all the products you 
            selected.`}
        isActive={isBulkEdit}
        closeModal={() => setIsBulkEdit(false)}
        style={{ height: "auto" }}
      >
        <secondaryComponents.BulkEditProduct
          type={type}
          selectedData={formData}
          setSelectedData={setFormData}
          closeModal={() => setIsBulkEdit(false)}
        />
      </RoutedModal>
    </>
  );
};
